import { Doughnut }  from 'vue-chartjs'

export default {
  
  extends: Doughnut,

  props : {
    pieChartData : {
      type : Array,
      required : true
    }
  },

  data() {
    return {
      params : {
        query         : this.$store.state.emptyQueryIndicator,
        clientType    : "active",
        status        : "all",
        access        : "all",
        primaryReason : "all",
        firstHomeBuyer: "all",
        clientSource  : "all",
        orderBy       : "last_activity_timestamp",
        orderType     : "desc",
        limit         : 30,
        offset        : 0
      },
      colors: ['#007ED6', '#52D726','#FF7300', '#0062BA', '#FFEC00', '#FF0000', '#7CDDDD', '#FFA9FD', '#9552EA', '#93F03B', '#F54F52', '#FFA32F', '#FFEC21', '#2B0B3F', '#57167E', '#9B3192', '#EA5F89']
    }
  },

  watch: {
    pieChartData: function (newData, oldData) {
      this.draw()
    }
  },

  computed : {
    labels() {
      let labels = []
      for(let i=0; i < this.pieChartData.length; i++) {
        labels.push(this.pieChartData[i].label)
      }

      return labels
    },

    values() {
      let values = []
      for(let i=0; i < this.pieChartData.length; i++) {
        values.push(this.pieChartData[i].count)
      }

      return values 
    },

    legendColors() {
      let bgColors = [];
      for(let i=0; i < this.pieChartData.length; i++) {
        bgColors.push(this.colors[i]);
      }
      return bgColors;
    }
  },

  mounted () {
    this.draw()
  },

  methods : {
    draw() {
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            backgroundColor: this.legendColors,
            data: this.values
          }
        ]
      }, {
        responsive         : true, 
        maintainAspectRatio: false,
        legend             : {
          display: true
        },
        onClick: this.handle
      })
    },

    handle(point, event) {
      const item = event[0];
      this.params.clientSource = item._view.label;
      this.$router.push({
        name   : 'client-list-search',
        params : this.params
      });
    }
  }
}